var React = require('react');

function MinibrainInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","stroke":"currentColor","d":"M184 0c30.9 0 56 25.07 56 56v400c0 30.9-25.1 56-56 56-28.9 0-52.7-21.9-55.7-50.1-5.2 1.4-10.7 2.1-16.3 2.1-35.35 0-64-28.7-64-64 0-7.4 1.27-14.6 3.59-21.2C21.43 367.4 0 338.2 0 304c0-31.9 18.71-59.5 45.77-72.3C37.15 220.8 32 206.1 32 192c0-30.7 21.59-56.3 50.41-62.6C80.84 123.9 80 118 80 112c0-29.94 20.6-55.08 48.3-62.07C131.3 21.86 155.1 0 184 0zm199.7 49.93C411.4 56.92 432 82.06 432 112c0 6-.8 11.9-2.4 17.4 28.8 6.3 50.4 31.9 50.4 62.6 0 14.1-5.1 28.8-13.8 39.7 27.1 12.8 45.8 40.4 45.8 72.3 0 34.2-21.4 63.4-51.6 74.8 2.3 6.6 3.6 13.8 3.6 21.2 0 35.3-28.7 64-64 64-5.6 0-11.1-.7-16.3-2.1-3 28.2-26.8 50.1-55.7 50.1-30.9 0-56-25.1-56-56V56c0-30.93 25.1-56 56-56 28.9 0 52.7 21.86 55.7 49.93z"}));
}

MinibrainInline.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = MinibrainInline;

MinibrainInline.default = MinibrainInline;
